import { Injectable } from '@angular/core';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { TrainersViewListingModel, TrainersViewGridParams } from 'common/models/page-models/Trainers View Model/trainers-view-grid-params.model';


@Injectable({
    providedIn: 'root'
})
export class TrainersViewGridDataService extends GridDataService<TrainersViewListingModel, AssignmentModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.trainersView, http, ss);
    }

    createInstance(): TrainersViewListingModel {
        return new TrainersViewListingModel();
    }


    override getGridParams(param): GridPostParams {
        let params;
        // console.log(param,'00000');
        
        params = new TrainersViewGridParams();
        // params.assignment_id = param.assigment_id;
        params.id = param.id;
        // params.timeslot_id = param.timeslot_info[0].timeslot_id

        return params;
    }


    //    override modifyGridPostParams(queryParams) {


    //     }
    override getDataParam() {
        return 'student_info';
    }

    override getExtraParam() {
        return 'details';
    }
    getDeleteUrl() {
        return '';
    }

    override transformDataModel(data: any, param) {
        super.transformDataModel(data, param);
        // console.log(data.details.student_info, "dataaaaaa");

        if (data.details && data.details.student_info) {
            // Iterate over the student_info array to apply transformations
            data.details.student_info.forEach((student) => {
                student.attended = student.attended_flag == 1 ? "Yes" : "No";
                student.score = student.score;
                student.student_feedback = student.student_feedback ? student.student_feedback : "";
                student.trainer_feedback_to_student = student.trainer_feedback_to_student ? student.trainer_feedback_to_student : "";
                student.trainer_feedback_to_admin = student.trainer_feedback_to_admin ? student.trainer_feedback_to_admin : "";
            })
            data.student_info = data.details.student_info

        return data;
    }

}
}
